import React from 'react';
import Category from "./Category";


const collapseHandler = (agencyName) => {
  const elem = document.getElementById(`${agencyName}categoriesContainer`);
  const header = document.querySelector(`#${agencyName}wrapper .coursesAgencyNameHeader`);
  
  if (elem && header) {
    const isCollapsed = elem.classList.contains('collapse');
    
    if (isCollapsed) {
      // Expanding
      elem.classList.remove('collapse');
      elem.style.height = '0px';
      
      // Get the natural height
      const naturalHeight = elem.scrollHeight;
      
      // Force a reflow to ensure the height change is applied
      const forceReflow = elem.offsetHeight; // eslint-disable-line no-unused-vars
      
      // Animate to natural height
      elem.style.height = naturalHeight + 'px';
      
      // Clean up after animation completes
      const cleanup = () => {
        if (!elem.classList.contains('collapse')) {
          elem.style.height = 'auto';
        }
        elem.removeEventListener('transitionend', cleanup);
      };
      
      elem.addEventListener('transitionend', cleanup);
      
    } else {
      // Collapsing
      // Set explicit height first
      elem.style.height = elem.scrollHeight + 'px';
      
      // Force reflow
      const forceReflow = elem.offsetHeight; // eslint-disable-line no-unused-vars
      
      // Animate to 0
      elem.style.height = '0px';
      elem.classList.add('collapse');
    }
  }
}

  
const Agency = ({ courseData = [] }) => (
  <>
    {courseData.length > 0 ? (
      courseData.map(({ agency, category }) => (
        <div id={`${agency}wrapper`} className="coursesAgencyWrapper"  key={`${agency}AgencyWrap`}>
          <h3 className="coursesAgencyNameHeader" onClick={() => collapseHandler(agency)}>{`${agency} Courses`}</h3>
          <div className="coursesCategoriesContainer collapse" id={`${agency}categoriesContainer`}>
            <Category category={category} agency={agency}/>
          </div>
        </div>
      ))
    ) : (
      <div className="courses-empty">
        <p>No courses available at this time.</p>
      </div>
    )}
  </>
)

export default Agency;